<template>
  <div class="">
    <div class="text title">
      Точний вибiр часу
    </div>

    <div class="time-block">
      <div class="date">
        <label for="date" class="label text">Дата </label> 
        <input v-model="date" type="date" name="date" class="text" id="date">
      </div>
      <div class="time"> 
        <label for="time" class="label text">Час </label>
        <input v-model="time" type="time" name="time" class="text" id="time">
      </div> 
      <div class="submits"> 
        <button class="download text" @click="submit('download')">Завантажити</button>
        <button class="find text" @click="submit('find')">Знайти</button>
      </div>
    </div>

  </div>
</template>


<script>

export default {

  name: "DownloadTimeSelectComponent",

  props: ['selected_date'],

  data () {
    return {
      date: '',
      time: '',
    }
  },

  methods: {

    submit(value) {
      this.selected_date({
        date:this.date,
        time:this.time,
        type:value
      })
    },    
  }
}
</script>



<style scoped>

.time-block {
  display: grid;
  justify-items: right;
 
}

.title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.label {
  font-size: 14px;
}

#date, #time {
  width: 165px;
  height: 31px;
  border-radius: 5px;
  margin-bottom: 10px;
  background: #848484; 
  outline: none;
  padding-left: 5px;
}

.submits {
  margin-bottom: 15px;
}

.download {
width: 122px;
height: 31px;
background: #848484;
border-radius: 10px;
display: inline-block;
border: none;
cursor: pointer;
transition-duration: 0.4s;
text-align: center;
font-size: 14px;
line-height: 16px;
font-weight: bold;
margin-right: 5px;

}

.download:hover {
  background-color: #5e5e5e;
}

.find {
width: 122px;
height: 31px;
background: #83931B;
border-radius: 10px;
display: inline-block;
border: none;
cursor: pointer;
transition-duration: 0.4s;
text-align: center;
font-size: 14px;
line-height: 16px;
font-weight: bold;
}

.find:hover {
  background-color: #647014;
}

</style>